import CloseIcon from 'assets/icons/close.svg';
import cn from 'classnames/bind';

import s from './CloseMenu.module.scss';

const cx = cn.bind(s);

const CloseMenu = ({ onClose, className, ...attrs }) => (
  <button
    className={cx('close', className)}
    onClick={onClose}
    {...attrs}
  >
    <CloseIcon />
  </button>
);

export default CloseMenu;
